import api from "../api/api";
import { V2_BASE_URL } from "../api/bases";
import { getPracticeId } from "../config/practice";

/*
 * Note Review billing calls (Billing tab + Sanity Check panel): /v1/{practice}/billing/claims/{worklist,
 * analyze, justify, submit, queue}. Pinned to v2 like the Billing module, fax and forms code
 * (`_gw: "v2-pinned"`): v2 answers with the Medicare coverage tables (api/coverage_policy), the same
 * verdict rule the Billing module uses; v1's copy still reads the retired lcpt_master.covered_icd_list,
 * so these calls skip the v1/v2 routing rules, never fall back to v1 and never trip the v2 breaker.
 */
export const CLAIMS_ROUTES = ["worklist", "analyze", "justify", "submit", "queue"];
const V2 = { baseURL: V2_BASE_URL, _gw: "v2-pinned" };

export const claimsPost = (route, body) => {
  if (!CLAIMS_ROUTES.includes(route)) throw new Error(`unknown claims route ${route}`);
  return api.post(`/v1/${getPracticeId()}/billing/claims/${route}`, body, V2);
};
